import { render, staticRenderFns } from "./orderResend.vue?vue&type=template&id=ae274d50"
import script from "./orderResend.js?vue&type=script&lang=js&external"
export * from "./orderResend.js?vue&type=script&lang=js&external"
import style0 from "./orderResend.vue?vue&type=style&index=0&id=ae274d50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports